import { FeatureFlags } from './FeatureFlags'

export default FeatureFlags
